<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<ng-container [ngSwitch]="reportSubType$ | async">

    <ng-container *ngSwitchCase="'detail'">
        <dash-gis-report-content-detail [definition]="definition"
                                  [keys]="keys"
                                  [dataSource]="dataSource"
                                  [dataForm]="tableDataForm"
                                  [dataFormGroup]="tableEditFormGroup"
                                  [tableEditActive]="tableEditActive"
                                  fxLayout="column" fxFlex="1 1 auto"></dash-gis-report-content-detail>
    </ng-container>

    <ng-container *ngSwitchCase="'tabular'">
        <dash-gis-report-content-tabular [definition]="definition"
                                   [keys]="keys"
                                   [dataSource]="dataSource"
                                   [dataFormGroup]="tableEditFormGroup"
                                   [dataForm]="tableDataForm"
                                   [tableEditActive]="tableEditActive"
                                   [mapEnabled]="mapEnabled"
                                   (editRowData)="onEditRowData($event)"
                                   fxLayout="column" fxFlex="1 1 auto"></dash-gis-report-content-tabular>
    </ng-container>

    <ng-container *ngSwitchCase="'chart'">
        <dash-gis-report-content-chart [definition]="definition"
                                 [keys]="keys"
                                 [dataSource]="dataSource" fxFill></dash-gis-report-content-chart>
    </ng-container>

    <ng-container *ngSwitchCase="'label'">
        <dash-gis-report-content-pdf [definition]="definition"
                               [keys]="keys"
                               [dataSource]="dataSource"></dash-gis-report-content-pdf>
    </ng-container>

    <ng-container *ngSwitchCase="'csv'">
    </ng-container>

    <ng-container *ngSwitchCase="'empty'">
        <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
    </ng-container>
    <div fxLayoutAlign="center center" *ngSwitchDefault>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</ng-container>

<!-- empty -->
<ng-template #emptyTemplate>
   <div>No records found</div>
</ng-template>

